import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-financial-white',
  templateUrl: './icon-financial-white.component.html',
  styles: []
})
export class IconFinancialWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
